import {
  Empty_NoSqlDoc,
  FBDTKeygenGeneric,
  MakeFBDocType,
  NoSqlDoc,
} from '@rabbit/firebase/doctype';
import { TenantLink } from './tenant';

/**
 * Enum for audit log action types
 */
export enum AuditLogActionType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

/**
 * Interface for audit log data
 */
export interface DTAuditLog extends NoSqlDoc {
  /** The entity type that was modified (e.g., 'holding', 'consumer', etc.) */
  entityType: string;

  /** The ID/link of the entity that was modified */
  entityLink: string;

  /** The action that was performed */
  action: AuditLogActionType;

  /** The user who performed the action */
  userLink?: string;

  /** The tenant in which the action was performed */
  tenantLink: TenantLink;

  /** Timestamp of when the action was performed */
  timestamp: number;

  /** Additional data related to the action (e.g., old and new values) */
  data: Record<string, any>;
}

/**
 * Firestore collection for audit logs
 */
export const FBD_AuditLog = MakeFBDocType<DTAuditLog>({
  name: 'Audit Log',
  collection: 'audit_logs',
  empty: () => {
    const result: DTAuditLog = {
      ...Empty_NoSqlDoc(),
      entityType: '',
      entityLink: '',
      action: AuditLogActionType.UPDATE,
      userLink: '',
      tenantLink: '',
      timestamp: new Date().getTime(),
      data: {},
    };
    return result;
  },
  keygen: FBDTKeygenGeneric,
});
